import { Assessment } from "./assessment";
import { internCertDetails } from "./internCertDetails";
import { VisitationFormat } from "./visitation-format";

export class ConferenceState {
  isValid: boolean;
  isDirty: boolean;
  lstObservations: any[];
  obsAssessment: Assessment;
  lstCert: internCertDetails;
  loadDuration: Function;
  getTimeIn24HourFormat: (timeIn12HourFormat: string) => string;
  fieldSupervisorDisplayName: string;
  signature: boolean;
  visitationFormatOptions: VisitationFormat[];
  conferenceNotes: string;
  collaborators: number[];
  otherCollaboratorDetail: string;
}
